import React, { useEffect } from 'react';
import cssImageEditorWindow from './ImageEditorWindow.module.scss';
import { GlobalLibs,PackageVariablesLibs } from 'bc-react-package';

const COMP_NAME = "ImageEditorWindow"
const IFRAME_ID = "iframImageEditor"
let mstrFrameID = IFRAME_ID
// let mstrAppWebDomain = ""
// let mstrImageBase64Gotton = ""
let mblnInitialized = false

function ImageEditorWindow(props)
{
    console.log(COMP_NAME + ".Begin")
    console.log("ImageEditorWindow.props:", props)
    console.log("ImageEditorWindow.props.Arguments:", props.Arguments)

    if (!mblnInitialized)
    {
        console.log(COMP_NAME + ".Begin: mblnInitialized: ", mblnInitialized)


        mblnInitialized = true
    }

    useEffect(() => {
        console.log(COMP_NAME + ".useEffect")

        // Similar to componentWillUnmount
        return () => {
            console.log(COMP_NAME + ".cleanup")

            GlobalLibs.RemoveWindowMessageEvent()

            mblnInitialized = false
        }
    }, [])

    function MessageReceived(Event)
    {
        console.log(COMP_NAME + ".MessageReceived: ", Event)

        // get the origin of event
        let strEventOrigin = Event.origin
        console.log("strEventOrigin: ", strEventOrigin)

        if (
            (strEventOrigin !== PackageVariablesLibs.SysConfig.AppWebDomain) &&
            (strEventOrigin !== "file://")
            )
        {
            // e.g. 從Google Classroom進來的 就不處理
            console.log("Not from my parent, cannot accept")
        }
        else
        {
            // console.log("Event.data: ", Event.data)
            // console.log("typeof(Event.data): ", typeof(Event.data))
            if (typeof (Event.data) === 'object')
            {
                if (
                    (typeof (Event.data.source) !== 'undefined') &&
                    (Event.data.source.indexOf('react-devtools') !== -1)
                    )
                {
                    return
                }
            }
            if (
                (typeof (Event.data) === 'string') &&
                (Event.data === "")
                )
            {
                return
            }

            let objCallData = JSON.parse(Event.data, true)
            /* 特別注意，
            Prelude的Menu也會trigger message, typeof 會是 function
            Sencha touch 的 DatePicker 也會trigger message, typeof 會是 function
             * 還不知道原因
             */

            // console.log("typeof(objCallData): ", typeof(objCallData))

            if (typeof (objCallData) === 'object')
            {
                // note that, Init Hand Shaking 時還沒有DCPCross <- richard: 用top，現階段不需要HandShaking
                // check if the message is from my parent

                console.log("strEventOrigin: ", strEventOrigin)
                console.log("PackageVariablesLibs.SysConfig.AppWebDomain: ", PackageVariablesLibs.SysConfig.AppWebDomain)
                if (strEventOrigin !== PackageVariablesLibs.SysConfig.AppWebDomain)
                {
                    console.log("not from my parent, cannot accept")
                    console.log("strEventOrigin: ", strEventOrigin)
                    console.log("PackageVariablesLibs.SysConfig.AppWebDomain: ", PackageVariablesLibs.SysConfig.AppWebDomain)

                    // not from my parent, cannot accept
                    // error 不做事
                }
                else
                {
                    // if (objCallData.Credential !== window.gSession.Acc.Credential)
                    if (objCallData.Credential !== window.gSession.Acc.Credential)
                    {
                        console.log("credential not match")
                        console.log("objCallData.Credential: ", objCallData.Credential)
                        // credential not match
                        // error 不做事
                    }
                    else
                    {
                        console.log("objCallData.Func: ", objCallData.Func)

                        switch (objCallData.Func)
                        {
                            case "CloseMeWithImage":
                                CloseMeWithImageHandler(objCallData.Args)
                                break
                            case "CloseMeWithoutImage":
                                CloseMeWithoutImageHandler()
                                break
                            // case "WebAudioRecorderReportInitErr":
                            //     WebAudioRecorderReportInitErr(objCallData.Args)
                            //     break
                            // case "WebAudioRecorderClosed":
                            //     WebAudioRecorderClosed(objCallData.Args)
                            //     break
                            // case "WebAudioRecorderEndStreaming":    // 結束搬移檔案
                            //     WebAudioRecorderEndStreaming(objCallData.Args)
                            //     break
                            // case "WebAudioRecorderError":           // 出現錯誤
                            //     WebAudioRecorderError(objCallData.Args)
                            //     break
                            default:
                                break
                        }
                    }
                }
            }
        }
    } // end of MessageReceived
    function CloseMeWithoutImageHandler()
    {
        console.log(COMP_NAME + ".CloseMeWithoutImageHandler: ")

        GlobalLibs.RemoveWindowMessageEvent()

        let objCallbackData = {
            "Action": "ImageEditorWindowCloseWithoutImage"
        }

        props.CallbackRef(objCallbackData)

        // window.removeEventListener("message", MessageReceived)
        // setImageBase64("")
    }
    function CloseMeWithImageHandler(Args)
    {
        console.log(COMP_NAME + ".CloseMeWithImageHandler: ", Args)

        // mstrImageBase64Gotton = Args.ImageBase64

        GlobalLibs.RemoveWindowMessageEvent()

        let objArguments = {
            "ImageBase64": Args.ImageBase64
        }

        let objCallbackData = {
            "Action": "ImageEditorWindowCloseWithImage",
            "Arguments": objArguments
        }

        props.CallbackRef(objCallbackData)

        // window.removeEventListener("message", MessageReceived)
        // setImageBase64("")
    }

    function IFrameOnLoaded()
    {
        console.log(COMP_NAME + ".IFrameOnLoaded: ")

        // mstrImageBase64Gotton = ""
        GlobalLibs.AddWindowMessageEvent(MessageReceived)
        // window.addEventListener("message", MessageReceived)

        CallIFrameAreYouReady()

    }
    function CallIFrameAreYouReady()
    {
        console.log(COMP_NAME + ".CallIFrameAreYouReady: ")

        var objMessage = {
            "Credential": window.gSession.Acc.Credential,
            "Func": "AreYouReady",
            "Args":
            {
                "ImageBase64": props.Arguments.ImageBase64
            }
        }
        let strMessage = JSON.stringify(objMessage)
        PostMessage(strMessage)
    }  // end of CallIFrameAreYouReady

    function PostMessage(Message)
    {
        console.log(COMP_NAME + ".PostMessage: ", Message)

        if (
            (typeof (window.frames[mstrFrameID]) !== 'undefined') &&
            (window.frames[mstrFrameID] !== null) &&
            (typeof (window.frames[mstrFrameID].postMessage) !== 'undefined') &&
            (window.frames[mstrFrameID].postMessage !== null)
            )
        {
            window.frames[mstrFrameID].postMessage(Message, PackageVariablesLibs.SysConfig.AppWebDomain)
        }
    } // end of PostMessage

    function RenderContent(ImageBase64)
    {
        console.log(COMP_NAME + ".RenderContent: ");

        if (ImageBase64 === "")
        {
            return null
        }

        var strTargetDomain = window.location.protocol + "//" + window.location.hostname
        if (
            (typeof (window.location.port) !== 'undefined') &&
            (window.location.port !== null) &&
            (window.location.port !== "")
            )
        {
            strTargetDomain += ":" + window.location.port
        }
        console.log("strTargetDomain: ", strTargetDomain)
        strTargetDomain = encodeURIComponent(strTargetDomain)

        var strIsInApp = window.gSession.App.InApp ? "true" : "false"
        var strQueryString = "TargetDomain=" + strTargetDomain
        strQueryString += "&Credential=" + window.gSession.Acc.Credential
        // strQueryString += "&Env=" + window.gSession.App.Env
        // strQueryString += "&CalledBySys=MFCR"
        strQueryString += "&SysType=" + window.gSession.App.SysType.toString();
        strQueryString += "&InApp=" + strIsInApp

        // let strWebUrl = "https://richard.local.betterchinese.com.tw/~richard/React/bc_image_editor/build/?" + strQueryString
        let strWebUrl = PackageVariablesLibs.SysConfig.ImageEditorServer + "?" + strQueryString;
        console.log("strWebUrl: ", strWebUrl)

        return (
            <iframe title={IFRAME_ID} name={IFRAME_ID} id={IFRAME_ID} onLoad={IFrameOnLoaded} className={cssImageEditorWindow.iframeImageEditor} src={strWebUrl}></iframe>
        )
    }

    return (
        <div className={cssImageEditorWindow.divMask}>
            <div className={cssImageEditorWindow.divMain}>
                {RenderContent(props.Arguments.ImageBase64)}
            </div>
        </div>
    )
}

export default ImageEditorWindow
